import { CREATE_SEARCH_PRODUCTS, SET_ACTIVE_SEARCH_PRODUCT } from '../../../../types/conversations/plugins'
import { getActiveUserId } from '../../../actionsHelpers'
import apiConversation from 'api/conversation'

import _get from 'lodash.get'

const searchPluginApi = apiConversation.plugins.search

const searchingProduct = (userId, product, jobToken = '', searching = true) => ({
  userId,
  product,
  jobToken,
  searching,
  type: `SEARCHING_${product.toUpperCase()}`,
})

const gettingProductResults = (userId, product, jobId = '', gettingResults = true) => ({
  userId,
  product,
  jobId,
  gettingResults,
  type: `GETTING_${product.toUpperCase()}_RESULTS`,
})

const sendingProductQuery = (userId, product) => ({
  userId,
  product,
  type: `SENDING_${product.toUpperCase()}_QUERY`,
})

const setSearchProductErrors = (userId, product, errors = {}) => ({
  userId,
  product,
  errors,
  type: `SET_${product.toUpperCase()}_SEARCH_ERRORS`,
})

const setProductSearchResults = (userId, product, results, totalResults, more = false) => ({
  userId,
  product,
  results,
  totalResults,
  more,
  type: `SET_${product.toUpperCase()}_SEARCH_RESULTS`,
})

const clearProductResults = (userId, product) => (dispatch) =>
  dispatch({
    userId,
    product,
    type: `CLEAR_${product.toUpperCase()}_RESULTS`,
  })

const cancelProductSearch = (userId, product, token) => (dispatch) => {
  searchPluginApi.cancelProductSearch({ userId, token })

  dispatch({ userId, product, type: `CANCEL_${product.toUpperCase()}_SEARCH` })
}

const setSearchType = (userId, activeProduct) => (dispatch, oldState) => {
  const product = _get(oldState(), `conversations.${userId}.plugins.search.products.${activeProduct}`)

  if (product) {
    const isResults = product.results.length === 0 && !product.searcher.show ? true : false

    if (isResults) {
      dispatch({ userId, type: `SHOW_${activeProduct.toUpperCase()}_SEARCHER` })
    }
  }

  return dispatch({
    userId,
    activeProduct,
    type: SET_ACTIVE_SEARCH_PRODUCT,
  })
}

const createSearchProducts = (userId) => (dispatch) => dispatch({ userId, type: CREATE_SEARCH_PRODUCTS })

const toggleSearcher = (product, user = {}) => (dispatch, getState) => {
  const userId = user.id || getActiveUserId(getState)

  return dispatch({ userId, product, type: `SHOW_${product.toUpperCase()}_SEARCHER` })
}

const toggleProductFilters = (userId, product) => (dispatch) => dispatch({ userId, product, type: `SHOW_${product.toUpperCase()}_FILTERS` })
const toggleProductSorter = (userId, product) => (dispatch) => dispatch({ userId, product, type: `SHOW_${product.toUpperCase()}_SORTER` })
const updateProductFilters = ({ userId, product, filters }) => (dispatch) =>
  dispatch({ userId, product, filters, type: `UPDATE_${product.toUpperCase()}_FILTERS` })
const updateProductQuery = ({ userId, product, query }) => (dispatch) =>
  dispatch({ userId, product, query, type: `UPDATE_${product.toUpperCase()}_QUERY` })

const updateSort = (userId, product, sort) => (dispatch) => dispatch({ userId, product, sort, type: `UPDATE_${product.toUpperCase()}_SORT` })

const selectProductResult = (userId, product, resultId) => (dispatch) =>
  dispatch({
    userId,
    product,
    resultId,
    type: `SELECT_${product.toUpperCase()}_RESULT`,
  })

const resetSelectedProductResults = (userId, product) => (dispatch) =>
  dispatch({
    userId,
    type: `RESET_SELECTED_${product.toUpperCase()}_RESULTS`,
  })

const toggleProductResultDetails = (userId, product, resultId) => (dispatch) =>
  dispatch({
    userId,
    product,
    resultId,
    type: `TOGGLE_${product.toUpperCase()}_RESULT_DETAILS`,
  })

const searchJobWatch = (token, timeout = 0, callback) => {
  return searchPluginApi
    .watchJob({ token })
    .then((response) => {
      const { data } = response
      const { tryAgain, results } = data

      if (tryAgain) {
        // Max num iterations 32 = 96seg
        if (timeout === 32) throw new Error('No results')

        return setTimeout(() => {
          searchJobWatch(token, timeout + 1, callback)
        }, 3000)
      }

      callback(null, results)
    })
    .catch(callback)
}

const handleJobWatch = (userId, product, token, timeout = undefined) => (dispatch) =>
  searchJobWatch(token, timeout, (error, response) => {
    dispatch(searchingProduct(userId, product, token, false))
    try {
      if (error) throw new Error(error)
      const { data } = response
      const { jobId } = data

      dispatch(getSearchResults({ userId, product, jobId }))
    } catch (error) {
      console.error('TCL: searchJobWatch -> error', error)
      dispatch(setSearchProductErrors(userId, product, { error }))
    }
  })

const searchProduct = (user, productQuery, product) => (dispatch) => {
  delete productQuery.resident
  if (productQuery.specialdiscounts) {
    productQuery.specialdiscounts = 'spanishResident'
  } else {
    productQuery.specialdiscounts = ''
  }

  const query = Object.assign({}, productQuery, { locale: user.locale })

  dispatch(sendingProductQuery(user.id, product))
  clearProductResults(user.id, product)(dispatch)

  return searchPluginApi
    .searchProduct({ userId: user.id, query, type: product })
    .then(({ data, status }) => {
      if (data.errorMessage) throw new Error(data.errorMessage)

      if (status === 200) {
        dispatch(sendingProductQuery(user.id, product, false))
        dispatch(searchingProduct(user.id, product, data.token))
        dispatch(setSearchProductErrors(user.id, product))

        toggleSearcher(product, user)(dispatch)

        handleJobWatch(user.id, product, data.token)(dispatch)
      } else {
        throw data.error
      }
    })
    .catch((error) => {
      console.error('TCL: searchProduct -> error', error)
      dispatch(setSearchProductErrors(user.id, product, { error: 'server-error' }))
    })
}

const getSearchResults = ({ userId, product, jobId, sort, withInbound = false, filters = {}, more = false, from = 0, size = 20 }) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(gettingProductResults(userId, product, jobId))

    const { inboundTime, outboundTime, travelTime, stops, stars, budget, score, airlines } = filters

    return searchPluginApi
      .getSearchResults({
        jobId,
        from,
        size,
        sort,
        score,
        withInbound: product === 'flight' ? withInbound : undefined,
        travelTime: travelTime > 0 ? travelTime : undefined,
        inboundTime: withInbound && inboundTime ? inboundTime.join(',') : undefined,
        outboundTime: outboundTime ? outboundTime.join(',') : undefined,
        stops: stops && stops.join(','),
        stars: stars && stars.join(','),
        budget: budget && budget.join(','),
        airlines: airlines ? airlines.join(',') : undefined,
        type: product,
      })
      .then(({ data, status }) => {
        dispatch(gettingProductResults(userId, product, jobId, false))

        if (data.errorMessage) throw new Error(data.errorMessage)

        if (status === 204) {
          dispatch(setProductSearchResults(userId, product, [], 0, more))
          return resolve()
        }

        const { data: results, filters = {}, totalResults } = data

        dispatch(setProductSearchResults(userId, product, results, totalResults || results.length, more))

        updateProductFilters({ userId, product, filters })(dispatch)
        return resolve()
      })
      .catch((error) => {
        dispatch(setSearchProductErrors(userId, product, { error }))
        return resolve()
      })
  })
}

const sendResults = ({ user, query, type, jobId, results = [], activate = false }) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return searchPluginApi
      .sendResults({
        user,
        query,
        type,
        jobId,
        activate,
        results,
      })
      .then(({ data, status }) => {
        if (status === 200) {
          resolve()
        } else {
          dispatch(setSearchProductErrors(user.id, type, { error: data.error }))
          return reject({ error: data.error })
        }
      })
      .catch((error) => {
        console.error('TCL: sendResults -> error', error)
        dispatch(setSearchProductErrors(user.id, type, { error }))
        return reject({ error })
      })
  })
}

export default {
  clearProductResults,
  setSearchType,
  searchProduct,
  sendResults,
  toggleSearcher,
  createSearchProducts,
  updateProductQuery,
  selectProductResult,
  toggleProductResultDetails,
  getSearchResults,
  toggleProductFilters,
  toggleProductSorter,
  updateSort,
  updateProductFilters,
  handleJobWatch,
  cancelProductSearch,
  resetSelectedProductResults,
}
